module.exports = __webpack_public_path__ + "static/media/almond.27869dd8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/svgs/ingredients/almond.svg
// module id = 714
// module chunks = 0